import Marquee from "react-fast-marquee";
import { Eyebrow } from "@/components/shared/Eyebrow";

// Premium monochrome logo marquee. Renders ONLY when real partner logos are supplied.
// `logos` = [{ name, src }]. Until then this section stays hidden from the public frontend.
export function Partners({ logos = [] }) {
  if (!logos || logos.length === 0) return null;

  return (
    <section data-testid="partners-section" className="relative bg-light py-20 md:py-24 border-y border-ink/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8 mb-12">
        <Eyebrow>ÇÖZÜMLERİMİZDE GÜVENİLİR TEKNOLOJİLER</Eyebrow>
      </div>
      <Marquee gradient gradientColor="#F5F7FA" gradientWidth={120} speed={40} pauseOnHover>
        {logos.map((l) => (
          <div
            key={l.name}
            data-testid={`partner-${l.name}`}
            className="mx-8 md:mx-14 flex items-center justify-center h-16 grayscale opacity-50 hover:opacity-100 hover:grayscale-0 transition-all duration-500"
          >
            <img src={l.src} alt={l.name} className="max-h-12 w-auto object-contain" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
